<template>
  <div class="demoReviewersTable">
    <div
      class="collapsible-wrapper"
      :class="{ 'open p-b': isOpen }"
    >
      <div class="reviewers-table">
        <div class="table-row table-head p-t-sm">
          <div class="cell avatar"></div>
          <div class="cell reviewer mute tt-up font-small">Reviewer</div>
          <div class="cell opened mute tt-up font-small">Opened</div>
          <div class="cell played mute tt-up font-small">Played</div>
          <div class="cell saved mute tt-up font-small">Saved</div>
          <div class="cell rejected mute tt-up font-small">Rejected</div>
          <div class="cell vote mute tt-up font-small">Vote</div>
        </div>

        <div
          v-for="reviewerId in reviewersList"
          :key="reviewerId"
          class="table-row"
        >
          <div class="cell avatar">
            <ImageWithInitials
              :src="allReviewers[reviewerId].profileImage"
              :name="allReviewers[reviewerId].name"
              :size="32"
            />
          </div>
          <div class="cell reviewer">
            {{ parsedData[reviewerId].name }}
          </div>
          <div class="cell opened">{{ parsedData[reviewerId].viewed }}</div>
          <div class="cell played" :class="mutedClass(parsedData[reviewerId].played)">
            {{ formatValue(parsedData[reviewerId].played) }}
          </div>
          <div class="cell saved" :class="mutedClass(parsedData[reviewerId].saved)">
            {{ formatValue(parsedData[reviewerId].saved) }}
          </div>
          <div class="cell rejected" :class="mutedClass(parsedData[reviewerId].rejected)">
            {{ formatValue(parsedData[reviewerId].rejected) }}
          </div>
          <div
            class="cell vote"
            :class="mutedClass(parsedData[reviewerId].ratings, true)"
            v-html="parsedData[reviewerId].ratings"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import ImageWithInitials from "@/components/misc/ImageWithInitials.vue";

export default {
  name: "DemoReviewersTable",
  components: {
    ImageWithInitials,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    reviewersList: {
      type: Array,
      required: true,
    },
    parsedData: {
      type: Object,
      required: true,
    },
    allReviewers: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formatValue(val) {
      if (!val || val === "No" || val === "Null") return "–";

      // Simple date validation (checks if val can be parsed into a real date)
      const d = new Date(val);
      if (!isNaN(d.getTime())) return "Yes";

      return val; // fallback if needed
    },
    mutedClass(val, skipFormat = false) {
      const display = skipFormat ? val : this.formatValue(val);
      return display === "No" || display === "–" ? "muted-value" : "";
    },
  },
};
  </script>
  
<style scoped lang="scss">
@import "@/scss/_variables.scss";
@import "@/scss/_mixins.scss";
@import "@/scss/_classes.scss";

  /* ---------------------------------------------------
     COLLAPSIBLE WRAPPER
  --------------------------------------------------- */
  .collapsible-wrapper {
    display: flex;
    flex-direction: column;
    overflow-x: auto;
    overflow-y: hidden;
    max-height: 0;
    opacity: 0;
    transition:
      max-height 0.4s ease,
      opacity 0.3s ease;
  }
  
  .collapsible-wrapper.open {
    max-height: 3000px;
    opacity: 1;
  }
  
  /* ---------------------------------------------------
     TABLE LAYOUT
  --------------------------------------------------- */
  .reviewers-table {
    width: 100%;
    min-width: 560px;
    color: white;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  
.table-row {
  display: grid;
  grid-template-columns: 32px 2.1fr 1.2fr 0.8fr 0.8fr 0.8fr 3.4fr;
  align-items: center;
  column-gap: 12px;
}

.cell {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cell.vote {
  white-space: normal;
  word-break: break-word;
}

.cell.reviewer {
  font-weight: 500;
}

.muted-value {
  color: #888;
}
  
  /* ---------------------------------------------------
     CHEVRON COLUMN
  --------------------------------------------------- */
  .chevron-width {
    width: 20px;
    flex-shrink: 0;
  }
  
  .chevron-cell {
    width: 20px;
    text-align: center;
  }
  
  /* ---------------------------------------------------
     TABLE BODY
  --------------------------------------------------- */
  
  .reviewers-table td {
    // padding: 16px;
    text-align: left;
    vertical-align: top;
  }
  .reviewer-name {
    font-weight: 500;
    padding-left: 16px;
  }
  .date-cell {
    color: #999;
    font-size: 0.875rem;
  }
  
  /* ---------------------------------------------------
     VOTE CELL
  --------------------------------------------------- */
  .vote-cell {
    color: #e0e0e0;
    font-size: 0.875rem;
  }
  
  /* ---------------------------------------------------
     TEXT ALIGNMENT
  --------------------------------------------------- */
  .text-left {
    text-align: left;
  }
  
  .text-center {
    text-align: center;
  }
  
  .text-right {
    text-align: right;
  }
  
  /* ---------------------------------------------------
     ROTATION ANIMATION
  --------------------------------------------------- */
  .rotate-transition {
    transition: transform 0.3s ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  
  .rotate-transition.rotate-90 {
    transform: rotate(90deg);
  }
</style>